import styled from 'styled-components';
import {CSS_CONSTANTS} from '../../../../css_variables';

export const ButtonWrapper = styled.div`
	display: flex;
	margin-top: 12px;
	flex-direction: row;
`;

export const AddTenantButtonWrapper = styled.div``;

export const HelpButtonWrapper = styled.div`
	margin-left: 8px;
`;

/* The connect half of the page - organisations and Add - in a box of its own, so the two halves
   read as two distinct things rather than one run-on list. */
export const ConnectSection = styled.div`
	padding: 20px;
	border: 1px solid ${CSS_CONSTANTS.color_light_grey};
	border-radius: 4px;
`;

/*
 * Its own bordered box, for two reasons. It reads as a distinct block rather than trailing off
 * the organisation list above it, and it gives this feature a styling scope of its own.
 *
 * The scope matters: settings_app.scss applies
 * `input[type='checkbox'] { margin-right: 5px; margin-bottom: 2px }` to the entire admin area,
 * and that bottom margin is what pushed the control off the text's centre line. Resetting it once
 * here covers every control in this section, now and later, instead of each one defending itself.
 * Doubled selector because the rule it overrides has the same specificity.
 *
 * The tick is drawn here as an SVG background rather than left to the shared control's ::after.
 * That ::after builds the mark from two rotated borders, and in this page's context one of the
 * two arms does not survive - what renders is a single diagonal stroke, a slash rather than a
 * checkmark. Reproduced on screen repeatedly; adjusting the ::after's size and position did not
 * fix it, because the mark's geometry depends on ambient rules this section does not control.
 *
 * A background image has no such dependency: it cannot lose an arm to a border rule, cannot be
 * clipped by the control's content box, and centres on the control itself. The path is the tick
 * from the agreed design.
 */
export const ConfigImportSection = styled.div`
	margin-top: 24px;
	padding: 20px;
	border: 1px solid ${CSS_CONSTANTS.color_light_grey};
	border-radius: 4px;

	h3 {
		margin: 0 0 4px;
	}

	p {
		margin: 0 0 20px;
		color: ${CSS_CONSTANTS.v2_text_gray};
	}

	&& input[type='checkbox'] {
		margin: 0;

		/* The shared control's border-drawn mark, replaced wholesale. */
		&:after {
			display: none;
		}

		&:checked {
			background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12'%3E%3Cpath d='M2.6 6.3 L4.9 8.6 L9.4 3.5' fill='none' stroke='%23ffffff' stroke-width='1.9' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
			background-repeat: no-repeat;
			background-position: center;
			background-size: 12px 12px;
		}
	}
`;

/* Explicit wrapper rather than a positional selector on the section's children: the organisation
   picker is a third-party component and what element it renders is not this file's to assume. */
export const ConfigImportRows = styled.div`
	margin-top: 16px;
`;

export const ConfigImportRow = styled.div`
	display: flex;
	align-items: center;
	min-height: 28px;

	/* Label is a sibling of the control, not its parent - see the component. */
	label {
		margin-left: 10px;
		cursor: pointer;
		line-height: 18px;
	}
`;

/* Per the design the status follows its label at a fixed distance rather than sitting in an
   aligned column, so the pair reads as one line of information. */
export const ConfigImportStatus = styled.span`
	margin-left: 12px;
	color: ${CSS_CONSTANTS.v2_text_gray};
	line-height: 18px;
`;

export const ConfigImportActions = styled.div`
	margin-top: 24px;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	gap: 12px;
`;

export const ConfigImportNotice = styled.p`
	&& {
		margin: 0 0 8px;
		color: ${CSS_CONSTANTS.v2_text_gray};
	}
`;
